module.exports = {"pagination":{"GetSavingsPlansCoverage":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetSavingsPlansUtilizationDetails":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListCostCategoryDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/ce-2017-10-25.paginators.json
// module id = 472
// module chunks = 1